import { useTheme } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

export const useBDrawerStyles = () => {
  const theme = useTheme();

  return {
    drawerPaper: {
      borderTopLeftRadius: "40px",
      borderTopRightRadius: "40px",
      maxHeight: "100vh", // Limit drawer height to 80% of viewport
      display: "flex",
      flexDirection: "column",
      overflowY: "hidden",
    } as SxProps<Theme>,

    topBar: {
      display: "flex",
      justifyContent: "center",
      py: 1.5,
    } as SxProps<Theme>,

    indicator: {
      width: 88,
      height: 6,
      borderRadius: 2.5,
      backgroundColor: "#E1E1E1",
    } as SxProps<Theme>,

    headerContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "12px 16px 16px 16px",
      position: "relative",
    } as SxProps<Theme>,

    headerContainerCentered: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      py: 1.5,
      px: 2,
      position: "relative",
      minHeight: 48,
    } as SxProps<Theme>,

    titleContainer: {
      flex: 1,
      ...theme.typography.h4,
      color: theme.palette.text.primary,
    } as SxProps<Theme>,

    closeButton: {
      border: "none",
      color: theme.palette.action.active,
      "&:hover": {
        backgroundColor: theme.palette.grey[100],
      },
    } as SxProps<Theme>,

    contentContainer: {
      flex: 1,
      px: 2,
      pt:2,
      borderTop: "none",
      borderBottom: "none",
      //overflowY: "auto",
      py:1,
      //maxHeight: "calc(100vh - 120px)", // Adjust based on your header/footer heights
    } as SxProps<Theme>,

    contentWithBottomPadding: {
      flex: 1,
      px: 2,
      borderTop: "none",
      borderBottom: "none",
      //overflowY: "auto",
      //maxHeight: "calc(100vh - 120px)", // Adjust based on your header/footer heights
    } as SxProps<Theme>,

    bottomBar: {
      display: "flex",
      justifyContent: "center",
      pb: 1.5,
    } as SxProps<Theme>,
  };
};
